import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CarrerjetService {
  constructor() {}

  generateJobFeed(job: any): string {
    const jobs = [
      {
        title: job?.Part?.nome,
        url: window.location.href,
        location: job?.Part?.cidade?.Cidade,
        company: job?.Empresa?.Caracteristica?.Nome,
        description: job?.Part?.descricaoVaga,
        salary: job?.Part?.salarioReal,
        date: job?.Datas?.Publicacao,
      },
    ];

    let xml = '<?xml version="1.0" encoding="UTF-8"?>\n<jobs>\n';
    jobs.forEach((job) => {
      xml += "  <job>\n";
      Object.keys(job).forEach((key) => {
        xml += `    <${key}>${job[key]}</${key}>\n`;
      });
      xml += "  </job>\n";
    });
    xml += `<careerjet-apply-data><![CDATA[apply_key=123456abcdef7890&jobTitle=${job?.Part?.nome}&jobLocation=${ job?.Part?.cidade?.Cidade }&jobCompanyName=${ job?.Empresa?.Caracteristica?.Nome }&postUrl=${ window.location.href}&phone=optional&coverletter=optional&hl=en_US]]></careerjet-apply-data>`
    xml +=
      "<programmatic><bid><cost_model>CPC</cost_model><currency_code>GBP</currency_code><amount>2.50</amount></bid></programmatic>";
    xml += "</jobs>";

    return xml;
  }
}
